<template>
  <div class="templates">
    <CustomTable title="Подготовительные работы" :rowsData="rowsData" :columns="workSetCheckGroupsLinkColumns"
      :loading="isFetching" :show-search="true" :custom-body="true" :sticky-header="true" :showHeaderAdd="true"
      :on-add-click="handleAddClick">
      <template #customBody="props">
        <q-tr>
          <CustomTableCell align="center">
            {{ props.row.work_set_check_group_link_id }}
          </CustomTableCell>

          <CustomTableCell align="center">
            {{ props.row.work_set_check_group_name }}
          </CustomTableCell>

          <CustomTableCell align="center">
            {{ props.row.prev_work_set_check_group_name }}
          </CustomTableCell>

          <CustomTableCell align="center">
            {{ props.row.company_name }}
          </CustomTableCell>
          <CustomTableCell align="center">
            {{ props.row.rowversion }}
          </CustomTableCell>

          <CustomTableCell align="center">
            <Clickable @click="() => this.handleUpdateClick(props.row)">
              <CustomIcon icon="edit" />
            </Clickable>
          </CustomTableCell>

          <CustomTableCell align="center">
            <CustomIcon icon="trash" :approve-mode="true" :loading="this.loading" :approve="() => this.onDeleteSubmit(props.row.work_set_check_group_link_id)
              " />
          </CustomTableCell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomIcon from "@/components/common/CustomIcon";
import Clickable from "@/components/common/Clickable";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import { appActions } from "@/services/store/modules/app_module/app_actions";
import {
  workSetCheckGroupsLinkColumns,
  getWorkSetCheckGroupsLink,
  addWorkSetCheckGroupsLink,
  updateWorkSetCheckGroupsLink,
  deleteWorkSetCheckGroupsLink,
} from "@/views/WorkSetCheckGroupsLink/services";
import { MODAL_NAMES } from "@/constants";

export default {
  name: "WorkSetCheckGroupsLink",
  components: { CustomTable, CustomTableCell, CustomIcon, Clickable },
  data() {
    return {
      workSetCheckGroupsLinkColumns,
      rowsData: [],
      isFetching: false,
      loading: false,
      snackbar: null,
    };
  },
  created() {
    this.snackbar = useCustomSnackbar();
  },
  methods: {
    showSucceedSnackbar(message) {
      if (this.snackbar) {
        this.snackbar.showSucceedSnackbar(message);
      }
    },

    async getData() {
      // this.isFetching = true;
      const res = await getWorkSetCheckGroupsLink();
      this.rowsData = res || [];
      // this.isFetching = false;
    },

    async handleAddClick() {
      this.$store.commit(
        appActions.showModal(MODAL_NAMES.ADD_WORK_SET_CHECK_GROUPS_LINK, {
          onSubmit: this.onAddSubmit,
          title: "Добавить подготовительную работу",
        })
      );
    },

    async handleUpdateClick(row) {
      this.$store.commit(
        appActions.showModal(MODAL_NAMES.ADD_WORK_SET_CHECK_GROUPS_LINK, {
          onSubmit: (body) =>
            this.onUpdateSubmit(row.work_set_check_group_link_id, body),
          title: "Изменить подготовительную работу",
          body: row,
        })
      );
    },

    async onAddSubmit(body) {
      try {
        const res = await addWorkSetCheckGroupsLink(body);
        if (res) {
          await this.getData();
          this.showSucceedSnackbar("Работа добавлена");
          this.$store.commit(appActions.closeModal());
        }
      } catch (error) {
        console.error("Error adding preliminary work:", error);
      }
    },

    async onUpdateSubmit(id, body) {
      try {
        const res = await updateWorkSetCheckGroupsLink(id, body);
        if (res) {
          await this.getData();
          this.showSucceedSnackbar("Работа обновлена");
          this.$store.commit(appActions.closeModal());
        }
      } catch (error) {
        console.error("Error updating preliminary work:", error);
      }
    },

    async onDeleteSubmit(id) {
      this.loading = true;
      try {
        const res = await deleteWorkSetCheckGroupsLink(id);
        if (res) {
          await this.getData();
          this.showSucceedSnackbar("Работа удалена");
        }
      } catch (error) {
        console.error("Error deleting preliminary work:", error);
      } finally {
        this.loading = false;
      }
    },
  },

  async getData() {
    const res = await getWorkSetCheckGroupsLink();
    console.log("API Response:", res); // Проверьте структуру данных
    console.log("First row:", res[0]); // Посмотрите на первую строку
    this.rowsData = res || [];
  },
  mounted() {
    this.getData();
  },
};
</script>
